// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3xDkD","inputDescription":"styles_inputDescription__2UKsE"};